import { render, staticRenderFns } from "./DatosDomicilio.vue?vue&type=template&id=fdce3bba&"
import script from "./DatosDomicilio.vue?vue&type=script&lang=js&"
export * from "./DatosDomicilio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports